/*
 * Copyright (c) 2021 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
export const createAccount = async (values) => {
  let requestBody = {
    username: values.username,
    password: values.password,
    confirmPassword: values.confirmPassword,
    email: values.email,
    token: values.token,
  }
  requestBody = JSON.stringify(requestBody)
  try {
    const response = await fetch('/api/create', {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
      body: requestBody,
    })

    let data = await response.json()
    data = { status: response.status, message: data.status, detail: data.detail }
    return data
  } catch (error) {
    return error
  }
}

export const forgotPassword = async (values) => {
  let requestBody = {
    email: values.email,
    token: values.token,
  }
  requestBody = JSON.stringify(requestBody)
  try {
    const response = await fetch('/api/forgot', {
      method: 'POST',
      cache: 'no-cache',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: requestBody,
    })

    let data = await response.json()
    data = { status: response.status, message: data.status }
    return data
  } catch (error) {
    return error
  }
}

export const changePassword = async (values) => {
  let requestBody = {
    oldPassword: values.oldPassword,
    newPassword: values.newPassword,
  }
  requestBody = JSON.stringify(requestBody)
  try {
    const response = await fetch('/api/changepassword', {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
      body: requestBody,
    })

    const data = await response.json()
    return { status: response.status, auth: data }
  } catch (error) {
    return error
  }
}

export const login = async (values) => {
  let requestBody = {
    username: values.username,
    password: values.password,
  }
  requestBody = JSON.stringify(requestBody)
  try {
    const response = await fetch('/api/login', {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
      body: requestBody,
    })

    const data = await response.json()
    return { status: response.status, auth: data }
  } catch (error) {
    return error
  }
}

export const logout = async () => {
  try {
    const response = await fetch('/api/logout', {
      method: 'POST',
      cache: 'no-cache',
    })

    const data = await response.json()
    return { status: response.status, auth: data }
  } catch (error) {
    return error
  }
}

export const authCheck = async () => {
  const response = await fetch('/api/authcheck', {
    method: 'GET',
    credentials: 'include',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
    },
  })

  return await response.json()
}
